import axios from "../api";
export const hideSbcSet = async (setId, isHidden) => {
    await axios.post("/hide-sbc-set", { setId, isHidden });
};
//# sourceMappingURL=hideSbcSet.js.map